
// ============================================
// TalkDetailScene - トーク詳細ページシーン
// ============================================

/**
 * GNS.TalkDetailScene
 * 
 * トーク詳細ページの処理
 * 
 * 機能:
 * - トーク記事表示
 * - スクロールに応じたセクション表示
 * - レスポンシブ対応
 */
GNS.TalkDetailScene = function (GNS) {
    const scene = GNS.create(GNS.AbstractScene);

    /**
     * 初期化処理
     * @param {Object} data 
     */
    scene.init = function (data) {
        scene._super.init.call(this, data);

        this.pages = [];

        // ヘッダー情報の取得
        const headerNodes = this.element.querySelectorAll(".talkdetail__header");
        if (headerNodes && headerNodes.length > 0) {
            this.header = new GNS.DisplayObject(headerNodes[0]);
            this.pages.push(this.header);
        }

        // 各セクションの取得
        const sectionNodes = this.element.querySelectorAll(".talkdetail__section");
        if (sectionNodes && sectionNodes.length > 0) {
            Array.from(sectionNodes).forEach((node) => {
                const sectionObj = new GNS.DisplayObject(node);

                // 子要素の取得
                sectionObj.subtitle = new GNS.DisplayObject(sectionObj.element.querySelector(".talkdetail__section__subtitle"));
                sectionObj.text = new GNS.DisplayObject(sectionObj.element.querySelector(".talkdetail__section__text"));
                sectionObj.image = new GNS.DisplayObject(sectionObj.element.querySelector(".talkdetail__section__image"));

                // 存在する要素のみページリストに追加（アニメーション対象とするため）
                if (sectionObj.subtitle.element) this.pages.push(sectionObj.subtitle);
                if (sectionObj.text.element) this.pages.push(sectionObj.text);
                if (sectionObj.image.element) this.pages.push(sectionObj.image);
            });
        }
    };

    /**
     * ロード処理
     */
    scene.load = function () {
        this.loadComplete();
    };

    /**
     * ロード完了時処理
     */
    scene._bind.loadComplete = function () {
        GNS.ResizeManager.addEventListener(this.resize);
        this.resize();
        scene._super.load.call(this);
    };

    /**
     * リサイズハンドラ
     * 各要素の矩形情報を更新し、スクロール判定を実行
     */
    scene._bind.resize = function () {
        for (let i = 0; i < this.pages.length; i++) {
            this.pages[i].rect = this.pages[i].getRect();
        }
        this.onscroll();
    };

    /**
     * 表示ハンドラ
     */
    scene.showHandler = function () {
        GNS.DOM.addEvent(document, "scroll", this.onscroll);
    };

    /**
     * 非表示ハンドラ
     */
    scene.hideHandler = function () {
        GNS.DOM.removeEvent(document, "scroll", this.onscroll);
    };

    /**
     * リセットハンドラ
     */
    scene.resetHandler = function () {
        GNS.ResizeManager.removeEventListener(this.resize);
    };

    /**
     * スクロールハンドラ
     * スクロール位置におうじて要素を表示（クラス付与）する
     */
    scene._bind.onscroll = function () {
        const pageSize = GNS.DOM.getPageSize();
        const displayHeight = pageSize.displayHeight;
        const scrollY = pageSize.scrollY;

        // 画面下から0.75画面分の位置をトリガーラインとする
        const triggerLine = scrollY + (displayHeight * 0.75);

        for (let i = 0; i < this.pages.length; i++) {
            const page = this.pages[i];

            // まだ表示されていない要素のみ判定
            if (!page.isShow) {
                // 要素のY位置がトリガーラインを超えたら表示
                if (triggerLine > page.rect.y) {
                    page.isShow = true;
                    page.addClass("show");
                }
            }
        }
    };

    return scene._self;
}(GNS);
